module.exports = __webpack_public_path__ + "static/media/no.37a27cc4.png";